import { CSSProperties, useMemo } from "react";

import { useServerSideProps } from "~/contexts/server-side-props";
import CrossCountry from "~/types/cross-country";
import Editorials from "~/types/editorials";
import { assertEditorialType } from "~/utils/editorial-utils";

import styles from "./product-badge.module.scss";

type Props = {
  product: CrossCountry.Product;
};

export default function ProductBadge({ product }: Props) {
  const { serverSideProps } = useServerSideProps();
  const contentUtils = serverSideProps.contentUtils;
  assertEditorialType<Editorials.ContentUtils>(contentUtils, "contentUtils");

  const editorialBadges = product.editorial_badges;

  const customBadge = contentUtils.fields.customBadge;
  const badgeStyle = useMemo(() => {
    if (!customBadge) {
      return {};
    }

    return {
      backgroundColor: customBadge.backgroundColor,
      color: customBadge.textColor,
      ...(customBadge.hasBorder && {
        borderColor: "#B5B5B5",
        borderWidth: 1,
        borderStyle: "solid",
      }),
    } as CSSProperties;
  }, [customBadge]);

  if (!editorialBadges?.length || !editorialBadges[0].length) return null;

  return (
    <div className={styles.badgeContainer}>
      <div className={styles.badge} style={badgeStyle}>
        {editorialBadges[0]}
      </div>
    </div>
  );
}
